module.exports = __webpack_public_path__ + "img/552.6c47e8ea.png";